import { initializeI18N } from '~admin/i18n';

export const bootstrap = (): void => {
  initializeI18N();
};



// WEBPACK FOOTER //
// ./bootstrap.ts